import React, { useState } from "react"
import tw, { css } from "twin.macro"
import Link from "next/link"
import GridContainer from "../page/gridContainer"
import { useTranslation } from "next-i18next"
import { ReactComponent as Instagram } from "../../assets/social/instagram.svg"
import { ReactComponent as YouTube } from "../../assets/social/youTube.svg"
import { MainLogo } from "../bonsaiLogo"
import { Modal } from "../modal"
import { ContactUs } from "./contactUs"

const social = [
  { href: "https://www.instagram.com/joinbonsai/", icon: <Instagram /> },
  { href: "https://www.youtube.com/@joinbonsai", icon: <YouTube /> },
]

interface FooterProp {
  isblack?: boolean
}
export default function Footer({ isblack }: FooterProp) {
  const { t } = useTranslation("footer")
  const [show, setShow] = useState(false)
  const modalProps = {
    show,
    setShow,
    component: <ContactUs />,
  }

  const handleClick = async (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault()
    setShow(true)
  }

  return (
    <footer
      data-theme="dark"
      tw="py-10 bg-background z-20 mt-auto"
      data-testid="footer"
      css={[
        css`
          --link-color: theme(colors.white) !important;
        `,
        isblack
          ? [
              tw`bg-base-6`,
              css`
                box-shadow: 0px 0px 12px #000000;
              `,
            ]
          : tw`bg-background shadow-base-2`,
      ]}
    >
      <GridContainer>
        <div tw="col-span-12 flex flex-col space-y-12 items-center text-white tablet-lg:(flex-row justify-between space-y-0)">
          <div tw="flex flex-col space-y-4 justify-center items-center tablet-lg:(justify-start items-start)">
            <MainLogo linked={true} />
            <Link href={`mailto:hello@joinbonsai.co`} passHref>
              <a target="_blank" tw="text-lg hover:underline" data-testid="email">
                {t("contact_us")}
              </a>
            </Link>
          </div>
          <div tw="space-x-6 tablet:space-x-10">
            <Link href={`https://joinbonsai.notion.site/Bonsai-FAQs-e04224f1b97e4c5381e5182077c421ad`} passHref>
              <a tw="text-md tablet:text-lg hover:underline" data-testid="faq">
                {t("faq")}
              </a>
            </Link>
            <span
              onClick={(e: React.MouseEvent<Element, MouseEvent>) => handleClick(e)}
              tw="text-md tablet:text-lg hover:underline"
              data-testid="help"
            >
              {t("help")}
            </span>
            <Link href={`https://joinbonsai.notion.site/Bonsai-Legal-bd067113f4fa4f63920e92388d1fd6e3`} passHref>
              <a tw="text-md tablet:text-lg hover:underline" data-testid="legal">
                {t("legal")}
              </a>
            </Link>
          </div>
          <div tw="flex space-x-10">
            {social.map(({ href, icon }, index) => (
              <Link href={href} passHref key={index}>
                <a target="_blank">{icon}</a>
              </Link>
            ))}
          </div>
        </div>
      </GridContainer>
      <Modal {...modalProps} />
    </footer>
  )
}
